export default __webpack_public_path__ + "static/Ratings_Reviews-eea316cd7c19230f17c16edf26f4983a.png";